export default __webpack_public_path__ + "static/media/kontakt16_9.eaeae51a.jpg";